/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { ImFilePdf } from "react-icons/im";
import { IoWarning } from "react-icons/io5";
import { Button, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useEffect, useState } from "react";
import ParcoursService from "../../services/services";
import CheckoutForm from "../../components/Paiement/Paiement";
import { CustomContainer } from "../../components/CustomContainer/CustomContainer";
import "./Signature.scss";


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC as string);


interface CustomWindow extends Window {
    dataLayer: any[],
};


export default function Signature() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const defaultError = "devis non trouvé ou lien expiré !";

    const [signatureInfos, setSignatureInfos] = useState<any>();
    const [erreurMessage, setErreurMessage] = useState<string>(defaultError);
    const [shouldPayFees, setShouldPayFees] = useState<boolean>(false);
    const [amount, setAmout] = useState<number>(0);


    useEffect(() => {
        if (queryParams.get('did') && queryParams.get('mid')) {
            ParcoursService.api_get_devis_signature_infos(queryParams.get('did') as string, queryParams.get('mid') as string).then((res) => {
                if (res) {
                    if (!res["ok"]) {
                        setErreurMessage(res["message"]);
                        window.scrollTo(0, 0);
                    } else {
                        setSignatureInfos(res['data']);
                        setShouldPayFees(res['data']?.should_pay_fees);
                        setAmout(res['data']?.frais_courtage / 100);
                    }
                }
            }).catch((error: any) => {
                setErreurMessage("Erreur : " + (error?.response?.data?.message || defaultError));
                window.scrollTo(0, 0);
            });
        };

        const appendGtmScript = () => {
            const scriptElement = document.createElement('script');
            scriptElement.id = 'gtm-script';
            scriptElement.innerHTML = `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-WMZCJLG5');
            `;

            const headElement = document.getElementById('head');
            if (headElement) {
                headElement.appendChild(scriptElement);
            }
        };
        appendGtmScript();

    }, []);


    const getBaseUrl = () => {
        return ParcoursService.baseUrl;
    };

    const isLinkExpired = () => {
        if (!signatureInfos) {
            return false;
        }
        return signatureInfos['is_link_expired'];
    };


    const formatDate = (inputDate: string): string => {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(inputDate)) {
            return inputDate;
        }

        // Parse and format the date using moment
        const formattedDate: string = moment(inputDate).format('DD/MM/YYYY');
        return formattedDate;
    }

    const goToYouSign = () => {
        window.open(signatureInfos['url_yousign'], '_blank');
        // Google tag manager
        if (typeof window !== 'undefined') {
            const customWindow = window as unknown as CustomWindow;
            customWindow.dataLayer.push({
                'event': 'formSubmit.Success'
            });
        }
    }

    return (
        <div className="signature-container" style={{ overflowX: "hidden" }}>
            <CustomContainer>
                {((): any => {
                    if ((isLinkExpired() || !signatureInfos)) {
                        return (
                            <Stack alignItems={"center"} className="fade-in-up">
                                <Stack bgcolor={"#f8d7da"} py={2.5} px={2} borderRadius={3} my={2} borderColor={"#f5c6cb"} boxShadow={2}>
                                    <small className='m-0 century align-center' style={{ color: "#7c2932", fontSize: 15.5, display: "flex", alignItems: "center" }}>
                                        <IoWarning size={22} /> {erreurMessage}
                                    </small>
                                </Stack>
                            </Stack>
                        )
                    }
                    if ((!isLinkExpired() && signatureInfos)) {
                        return (
                            <Stack width={"100%"} py={3} gap={2}>
                                <div className="signature-header fade-in-up">
                                    <h3 className="text-pink" style={{ textTransform: "uppercase" }}>Adhésion électronique</h3>
                                </div>
                                {/* Payment confirmation */}
                                {signatureInfos?.show_message_paiement && (
                                    <div className="payment-confirmation fade-in-up">
                                        <span className="payment-icon">💳</span>
                                        <span>
                                            Des frais de courtage d'un montant de <span className="century payment-amount">{amount} €</span> ont été réglés par carte bancaire.
                                            Vous trouverez ci-dessous une note d'information sur le paiement stipulant que les frais ont bien été réglés.
                                        </span>
                                    </div>
                                )}
                                <Stack width={"100%"} className="products-container">
                                    <Stack p={3} gap={2}>
                                        {
                                            signatureInfos['devis_produits'].map((product: any, index: number) => (
                                                <div className="product fade-in-up" key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                                                    <div className="product-header">
                                                        <h4 className="nom-produit century-bold m-0" style={{ fontSize: 18 }}>{product.nom_produit}</h4>
                                                        <div className="date-effet">
                                                            <span className="date-icon">📅</span>
                                                            <span className="date-text">Effet au {formatDate(product.date_effet)}</span>
                                                        </div>
                                                    </div>

                                                    <Stack gap={1} mt={1}>
                                                        <p className="nom-formule m-0 century">Formule(s) recommandée(s) : {product.nom_formule}</p>

                                                        {product.is_devis_prevoyance && (
                                                            <h6 className="m-0 century">
                                                                <strong>Couverture prévoyance pour</strong> : {product.member_nom} {product.member_prenom}
                                                            </h6>
                                                        )}

                                                        {product.is_devis_sante && (
                                                            <h6 className="m-0 century">
                                                                <strong>Couverture mutuelle santé pour</strong> : {product.member_nom} {product.member_prenom}
                                                            </h6>
                                                        )}

                                                        <h6 className="m-0 century">
                                                            {product.conjoint && (
                                                                <span>Votre conjoint {product.conjoint.nom} {product.conjoint.prenom}</span>
                                                            )}

                                                            {product.nb_enfants > 0 && (
                                                                <span>
                                                                    {product.nb_enfants === 1 ? ' et votre enfant' : ` et vos ${product.nb_enfants} enfants`}
                                                                </span>
                                                            )}
                                                        </h6>
                                                    </Stack>

                                                    <Stack mt={1.5}>
                                                        {
                                                            product?.devis_garanties?.length > 0 && (
                                                                <ul className="garanties">
                                                                    {product.devis_garanties.map((garantie: any, garantieIndex: number) => (
                                                                        <li key={garantieIndex}>
                                                                            <a
                                                                                href={getBaseUrl() + garantie.file_path}
                                                                                className="garantie"
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                <ImFilePdf size={32} />
                                                                                <small className="garantie-file century">{garantie.file_name}</small>
                                                                            </a>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            )
                                                        }
                                                    </Stack>
                                                </div>
                                            ))
                                        }
                                    </Stack>
                                </Stack>

                                {/* All Garanties Section */}
                                {signatureInfos?.all_garanties && signatureInfos.all_garanties.length > 0 && (
                                    <div className="garanties-section fade-in-up">
                                        <h4 className="century-bold text-center" style={{ color: "#2f4c87", marginBottom: "1.5rem" }}>
                                            Documents de garanties
                                        </h4>
                                        <ul className="garanties">
                                            {signatureInfos.all_garanties.map((garantie: any, index: number) => (
                                                <li key={index}>
                                                    <a
                                                        href={getBaseUrl() + garantie.file_path}
                                                        className="garantie"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <ImFilePdf size={32} />
                                                        <small className="garantie-file century">{garantie.file_name}</small>
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                <div className="subscribers-section fade-in-up">
                                    <Stack gap={3}>
                                        <h4 className="century-bold text-center" style={{ color: "#2f4c87" }}>
                                            Cette demande d'adhésion concerne les signataires suivants :
                                        </h4>
                                        <table className="subscribers">
                                            <thead>
                                                <tr>
                                                    <td>Nom et prénom</td>
                                                    <td>Date de naissance</td>
                                                    <td>Régime social</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {signatureInfos['devis_subscribers'].map((subscriber: any, index: number) => (
                                                    <tr key={index}>
                                                        <td>{`${subscriber.nom} ${subscriber.prenom}`}</td>
                                                        <td> {formatDate(subscriber.date_naissance)}</td>
                                                        <td>{subscriber.regime_social}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Stack>
                                </div>

                                {/* garanties */}
                                <div className="fade-in-up">
                                    <p className="garanties-info">
                                        Pour plus d'informations, nous vous invitons à consulter le tableau des garanties ou les conditions
                                        générales du contrat ci-dessus.
                                    </p>
                                </div>

                                {/* signature access */}
                                <div className="signature-actions fade-in-up">
                                    {!signatureInfos['has_expired_devis'] ? (
                                        <Stack my={4} alignItems={"center"}>
                                            {
                                                shouldPayFees ? (
                                                    <Elements stripe={stripePromise}>
                                                        <CheckoutForm amount={amount} devisId={queryParams.get('did') as string} />
                                                    </Elements>
                                                ) : (
                                                    <Button
                                                        className="btn-signature"
                                                        onClick={() => goToYouSign()}
                                                        disabled={!signatureInfos || !signatureInfos['url_yousign']}
                                                    >
                                                        <span style={{ color: "white" }}>
                                                            {signatureInfos && signatureInfos['url_yousign']
                                                                ? 'Accéder aux documents à signer'
                                                                : 'URL de signature non disponible'
                                                            }
                                                        </span>
                                                    </Button>
                                                )
                                            }
                                        </Stack>
                                    ) : (
                                        <Stack alignItems={"center"} my={3}>
                                            <Stack bgcolor={"#f8d7da"} py={2.5} px={2} borderRadius={3} my={2} borderColor={"#f5c6cb"} boxShadow={2}>
                                                <small className='m-0 century align-center' style={{ color: "#7c2932", fontSize: 15.5, display: "flex", alignItems: "center" }}>
                                                    <IoWarning size={22} /> Date d'effet expirée, veuillez nous recontacter pour continuer votre adhésion.
                                                </small>
                                            </Stack>
                                        </Stack>
                                    )}
                                </div>

                                {/* instructions */}
                                <div className="instructions-section fade-in-up">
                                    <h4 className="century-bold text-center" style={{ color: "#2f4c87", marginBottom: "1.5rem" }}>
                                        Instructions pour la signature
                                    </h4>
                                    <ol>
                                        <li>Accédez à la signature électronique en cliquant sur le bouton "Accéder aux documents à signer".</li>
                                        <li>Une fois les documents affichés, signez-les à l'aide de la signature électronique.</li>
                                        <li>
                                            Vous recevrez immédiatement une copie de votre demande d'adhésion par email. Votre demande sera aussitôt
                                            transmise à la compagnie pour traitement.
                                        </li>
                                        <li>
                                            Un certificat d'adhésion valant acceptation de votre demande et précisant la date d'effet de votre
                                            adhésion ainsi qu'une carte de tiers payant vous seront adressés dans les meilleurs délais.
                                        </li>
                                    </ol>
                                </div>
                            </Stack >
                        )
                    }
                })()}
            </CustomContainer >
        </div>
    );
};